import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
export function BonusSection() {
  return <section className="w-full py-20 px-4 bg-brand-alt border-y border-brand-card" data-id="element-12">
      <div className="max-w-5xl mx-auto space-y-20" data-id="element-13">
        {/* PART 1: Transition Text */}

        {/* PART 2: Bonus #1 Card */}
        <div className="bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8 shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-14">
          <div className="flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-15">
            <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/9y2L1js4T8YfFgLivm368J/Bono_1.jpg" alt="Bono 1: Manejo de Bank" className="w-full h-auto rounded-xl shadow-lg border border-brand-gold/20" data-id="element-17" />
            </div>
            <div className="w-full md:w-2/3 space-y-6" data-id="element-18">
              <div data-id="element-19">
                <span className="inline-flex items-center gap-2 px-3 py-1 bg-brand-gold/10 text-brand-gold rounded-full text-sm font-bold mb-4 border border-brand-gold/20" data-id="element-20">
                  <GiftIcon className="w-4 h-4" data-id="element-21" /> BONO #1
                </span>
                <h3 className="text-3xl text-brand-text font-heading mb-2" data-id="element-22">
                  Manejo de Bank
                </h3>
                <p className="text-lg text-brand-gold italic" data-id="element-23">
                  Administra Tu Dinero Como un Profesional
                </p>
              </div>

              <div className="mt-8 bg-brand-bg rounded-xl p-6 border border-brand-card" data-id="element-24">
                <div className="flex justify-between items-center py-2 border-b border-brand-card" data-id="element-25">
                  <span className="text-brand-muted" data-id="element-26">Valor real</span>
                  <span className="text-brand-muted line-through" data-id="element-27">$197.00</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-brand-card" data-id="element-28">
                  <span className="text-brand-text" data-id="element-29">Tu precio hoy</span>
                  <span className="text-brand-text" data-id="element-30">$17.36</span>
                </div>
                <div className="flex justify-between items-center py-2 pt-4" data-id="element-31">
                  <span className="text-brand-text font-bold" data-id="element-32">
                    Con tu acceso hoy
                  </span>
                  <span className="text-brand-green font-bold flex items-center gap-2" data-id="element-33">
                    <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-34"></span>{' '}
                    GRATIS
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PART 3: Bonus #2 Card */}
        <div className="bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8 shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-35">
          <div className="flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-36">
            <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-37">
              <img src="https://cdn.magicpatterns.com/uploads/wZGjgqurw5wKGnh8bxRrbh/Bono_2.jpg" alt="Bono 2: Entiende Apuestas" className="w-full h-auto rounded-xl shadow-lg border border-brand-gold/20" data-id="element-38" />
            </div>
            <div className="w-full md:w-2/3 space-y-6" data-id="element-39">
              <div data-id="element-40">
                <span className="inline-flex items-center gap-2 px-3 py-1 bg-brand-gold/10 text-brand-gold rounded-full text-sm font-bold mb-4 border border-brand-gold/20" data-id="element-41">
                  <GiftIcon className="w-4 h-4" data-id="element-42" /> BONO #2
                </span>
                <h3 className="text-3xl text-brand-text font-heading mb-2" data-id="element-43">
                  Entiende Apuestas
                </h3>
                <p className="text-lg text-brand-gold italic" data-id="element-44">
                  Terminología Completa Para Apostadores Serios
                </p>
              </div>

              <div className="mt-8 bg-brand-bg rounded-xl p-6 border border-brand-card" data-id="element-45">
                <div className="flex justify-between items-center py-2 border-b border-brand-card" data-id="element-46">
                  <span className="text-brand-muted" data-id="element-47">Valor real</span>
                  <span className="text-brand-muted line-through" data-id="element-48">$97.00</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-brand-card" data-id="element-49">
                  <span className="text-brand-text" data-id="element-50">Tu precio hoy</span>
                  <span className="text-brand-text" data-id="element-51">$15.39</span>
                </div>
                <div className="flex justify-between items-center py-2 pt-4" data-id="element-52">
                  <span className="text-brand-text font-bold" data-id="element-53">
                    Con tu acceso hoy
                  </span>
                  <span className="text-brand-green font-bold flex items-center gap-2" data-id="element-54">
                    <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-55"></span>{' '}
                    GRATIS
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}